/**
 * @file View
 * @author Yu Zong(liuxuanzy@qq.com)
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useRef } from 'react';
import { useCombineRef, useRefCallback } from '@tencent/glue-react-use';
import { useElementSize } from '@tencent/glue-react-boundary';
import { useStyleTransform } from '../hooks/useStyleTransform';
import { Device } from './modules/DeviceModule';
export function View(props) {
    var id = props.id, _a = props.style, elemStyle = _a === void 0 ? {} : _a, _b = props.className, elemClassName = _b === void 0 ? '' : _b, children = props.children, onClick = props.onClick, onLoad = props.onLoad, onLayout = props.onLayout, onTouchStart = props.onTouchStart, onTouchMove = props.onTouchMove, onTouchEnd = props.onTouchEnd, onTouchCancel = props.onTouchCancel;
    var _c = useStyleTransform(elemStyle, 'xj-h5-view', elemClassName), styleRef = _c.ref, config = __rest(_c, ["ref"]);
    var onLoadCallback = useRefCallback(onLoad);
    var touching = useRef(false);
    var onH5TouchStart = useRefCallback(function (e) {
        if (onTouchStart) {
            touching.current = true;
            var ratio = Device.getRatio();
            onTouchStart({
                x: e.targetTouches[0].clientX / ratio,
                y: e.targetTouches[0].clientY / ratio,
                originalEvent: e,
            });
        }
    });
    var onH5TouchMove = useRefCallback(function (e) {
        if (onTouchMove && touching.current) {
            var ratio = Device.getRatio();
            onTouchMove({
                x: e.targetTouches[0].clientX / ratio,
                y: e.targetTouches[0].clientY / ratio,
                originalEvent: e,
            });
        }
    });
    var onH5TouchEnd = useRefCallback(function (e) {
        if (onTouchEnd && touching.current) {
            var ratio = Device.getRatio();
            onTouchEnd({
                x: e.changedTouches[0].clientX / ratio,
                y: e.changedTouches[0].clientY / ratio,
                originalEvent: e,
            });
        }
        touching.current = false;
    });
    var onH5TouchCancel = useRefCallback(function (e) {
        if (onTouchCancel && touching.current) {
            var ratio = Device.getRatio();
            onTouchCancel({
                x: e.changedTouches[0].clientX / ratio,
                y: e.changedTouches[0].clientY / ratio,
                originalEvent: e,
            });
        }
        touching.current = false;
    });
    useEffect(onLoadCallback, []);
    var sizeRef = useElementSize(function () { return Boolean(onLayout); }, function (newSize) {
        var ratio = Device.getRatio();
        onLayout === null || onLayout === void 0 ? void 0 : onLayout({
            width: newSize.width / ratio,
            height: newSize.height / ratio,
        });
    })[0];
    var ref = useCombineRef(styleRef, sizeRef);
    return (React.createElement("div", __assign({}, config, { ref: ref, id: id, onClick: onClick, onTouchStart: onTouchStart && onH5TouchStart, onTouchMove: onTouchStart && onH5TouchMove, onTouchEnd: onTouchStart && onH5TouchEnd, onTouchCancel: onTouchStart && onH5TouchCancel }), children));
}
